// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__v0lu3","colMin":"styles_colMin__23jtx","colCheckbox":"styles_colCheckbox__dPrPy"};